var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBooking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#C5606A;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2",
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Air Tickets",
    id: "Air_Tickets"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 60,
    width: 60
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.76,37.45a1,1,0,0,0-1,1v3.58a1,1,0,0,0,2.06,0V38.48A1,1,0,0,0,14.76,37.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.79,31.33a1,1,0,0,0-2.06,0v3.58a1,1,0,0,0,2.06,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.52,32.09h4.24a1,1,0,0,0,0-2.06H21.52a1,1,0,1,0,0,2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M35.93,38.36a1,1,0,0,0-1-1H21.52a1,1,0,1,0,0,2.06H34.9A1,1,0,0,0,35.93,38.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.52,41.3a1,1,0,1,0,0,2.06h10a1,1,0,0,0,0-2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M56,33.42,51.12,21,54,18.17a4.49,4.49,0,0,0,1.29-2.8,3,3,0,0,0-.88-2.46v0A3.1,3.1,0,0,0,51.94,12a4.51,4.51,0,0,0-2.78,1.29l-2.9,2.9L33.89,11.35a1,1,0,0,0-1.11.23l-2.26,2.26a1,1,0,0,0-.3.79,1.06,1.06,0,0,0,.3.67.39.39,0,0,0,.1.08l2.47,1.92-.31.31a1,1,0,0,0,1.46,1.46l.49-.49,1.75,1.36-.32.32a1,1,0,0,0,1.46,1.46l.5-.5,1.75,1.36L36.49,26l-.53.57-3.27-1.26a1,1,0,0,0-1.1.24L30.14,27a1,1,0,0,0,0,1.46l3.07,3.07c-.05.18-.11.36-.15.54a1.83,1.83,0,0,0,2.22,2.22l.53-.15,3.08,3.07a1,1,0,0,0,1.45,0l1.46-1.46a1,1,0,0,0,.23-1.1l-1.25-3.27c.19-.17.38-.34.56-.52l3.38-3.39,1.37,1.76-.5.49a1,1,0,0,0,0,1.46,1,1,0,0,0,1.46,0l.31-.31,1.37,1.75-.49.49a1,1,0,0,0,1.46,1.46l.3-.31,1.92,2.47.09.1a1.09,1.09,0,0,0,.66.3,1,1,0,0,0,.8-.3l2.26-2.27A1,1,0,0,0,56,33.42ZM34,29.4l-1.71-1.71.26-.25,2.1.8A13.2,13.2,0,0,0,34,29.4ZM32.8,14.47l1-1,10.91,4.27-3.33,3.33ZM39.61,35l-1.7-1.7c.39-.2.78-.42,1.15-.65l.81,2.1Zm.27-5.62a11.07,11.07,0,0,1-4.72,2.79A11,11,0,0,1,38,27.42L50.62,14.75a2.42,2.42,0,0,1,1.5-.7,1,1,0,0,1,.81.3h0a1,1,0,0,1,.28.88,2.33,2.33,0,0,1-.69,1.47ZM52.83,34.5,46.19,26l3.34-3.33,4.26,10.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.52,32.09h4.24a1,1,0,0,0,0-2.06H21.52a1,1,0,1,0,0,2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20.49,38.36a1,1,0,0,0,1,1H34.89a1,1,0,1,0,0-2.06H21.52A1,1,0,0,0,20.49,38.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.52,41.3a1,1,0,1,0,0,2.06h10a1,1,0,1,0,0-2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M49.82,39.56a1,1,0,0,0-1,1v5.73a.35.35,0,0,1-.35.34H7.06l1.51-2a1,1,0,0,0,0-1.24l-2.28-3,2.28-3a1,1,0,0,0,0-1.23L6.29,33,8.57,30a1,1,0,0,0,0-1.23l-1.51-2H24.9a1,1,0,1,0,0-2.06H11.09l.9-4.23L29,24a1,1,0,0,0,.43-2l-17.3-3.68a1.72,1.72,0,0,0-2,1.32L9,24.67H5a1,1,0,0,0-.83,1.65l2.29,3-2.29,3a1.05,1.05,0,0,0,0,1.24L6.46,36.7l-2.29,3a1.05,1.05,0,0,0,0,1.24L6.46,44l-2.29,3a1,1,0,0,0-.09,1.07,1,1,0,0,0,.92.58H48.44a2.41,2.41,0,0,0,2.41-2.41V40.59A1,1,0,0,0,49.82,39.56Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooking);
export default __webpack_public_path__ + "static/media/booking.80f434bc20f033234ec5d1b9511eac18.svg";
export { ForwardRef as ReactComponent };